import React from 'react';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';
import { BREAKPOINTS, COLORS } from '../../styles/variables';
import { H1 } from '../../styles/textTags';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isEventPage = location.pathname.startsWith('/event/');
  const yaDolzgenSozdavatEtuPeremennuiuChtobiBilPerenos = "Культурная гастрономия \nв музеях Ленобласти"
  const handleLogoClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
    }
  };

  return (
    <HeaderWr $isEventPage={isEventPage}>
      <LogoImg
        src='/imgs/logo.png'
        alt='Музейное агентсво'
        draggable={false}
        $isEventPage={isEventPage}
        onClick={handleLogoClick}
        style={{ cursor: 'pointer' }}
      />
      <HeaderH1 $isEventPage={isEventPage}>{yaDolzgenSozdavatEtuPeremennuiuChtobiBilPerenos}</HeaderH1>
    </HeaderWr>
  );
};

const HeaderWr = styled.header`
  position: relative;
  z-index: 222;
  width: 100%;

  height: ${({ $isEventPage }) => ($isEventPage ? '120px' : '160px')};
  color: ${COLORS.grey};

  display: flex;
  align-items: center;
  gap: 32px;
  padding: 0 100px;

  background-color: ${COLORS.green};

  @media ${BREAKPOINTS.laptop} {
    padding: 0 7.14vw;
    height: ${({ $isEventPage }) => ($isEventPage ? '8.57vw' : '11.43vw')};
    gap: 2.29vw;
  }
  @media ${BREAKPOINTS.mobile} {
    padding: 0 8.75vw;
    height: 25vw;
    gap: 3.33vw;
  }
`;

const LogoImg = styled.img`
  width: ${({ $isEventPage }) => ($isEventPage ? '100px' : '116px')};
  height: ${({ $isEventPage }) => ($isEventPage ? '100px' : '116px')};

  @media ${BREAKPOINTS.laptop} {
    width: ${({ $isEventPage }) => ($isEventPage ? '7.01vw' : '8.29vw')};
    height: ${({ $isEventPage }) => ($isEventPage ? '7vw' : '8.29vw')};
  }
  @media ${BREAKPOINTS.mobile} {
    width: ${({ $isEventPage }) => ($isEventPage ? '16.67vw' : '16.67vw')};
    height: ${({ $isEventPage }) => ($isEventPage ? '16.67vw' : '16.67vw')};
  }
`;

const HeaderH1 = styled(H1)`
  font-size: ${({ $isEventPage }) => ($isEventPage ? '32px' : '48px')};
  white-space: ${({ $isEventPage }) => ($isEventPage ? 'auto' : 'pre-wrap')};
  @media ${BREAKPOINTS.laptop} {
    font-size: ${({ $isEventPage }) => ($isEventPage ? '2.22vw' : '3.33vw')};
  }
  @media ${BREAKPOINTS.mobile} {
    font-size: ${({ $isEventPage }) => ($isEventPage ? '4.58vw' : '4.58vw')};
  }
`;

export default Header;
